import { useState } from "react";

import { PhotoCamera } from "@mui/icons-material";
import { Button } from "@mui/material";
import dayjs from "dayjs";
import html2canvas from "html2canvas";

const ExportImage = ({ disabled }) => {
  const [isExporting, setIsExporting] = useState(false);
  
  const exportImage = async () => {
    const commentThemesDiv = document.getElementById("amplify-themes");
    if (!commentThemesDiv) return;
    setIsExporting(true);
    try {
      const canvas = await html2canvas(commentThemesDiv);
      const imageUrl = canvas.toDataURL("image/jpeg");
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = `amplify_themes_${dayjs().format("DD_MM_YYYY")}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting image:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      startIcon={<PhotoCamera />}
      onClick={exportImage}
      disabled={isExporting || disabled}
    >
      {isExporting ? "Exporting..." : "Export"}
    </Button>      
  );
};

export default ExportImage;
